import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ContactForm from './ContactForm';

const Navigation = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [contactModalOpen, setContactModalOpen] = useState(false);
  
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const openContactModal = (e) => {
    e.preventDefault();
    setContactModalOpen(true);
  };

  const closeContactModal = () => {
    setContactModalOpen(false);
  };

  const navigate = useNavigate();

  const handleMetricsClick = (e) => {
    e.preventDefault();
    const currentPath = window.location.pathname;
    
    if (currentPath === '/') {
      const metricsSection = document.getElementById('metrics-section');
      if (metricsSection) {
        metricsSection.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate('/#metrics-section');
    }
    
    setMenuOpen(false);
  };

  return (
    <>
      <div className="nav_fixed">
        <div className="nav_component" style={{ backgroundColor: '#222126' }}>
          <div className="padding-global">
            <div className="container-large">
              <div className="nav_container">
                <div className="nav-banner hide-mobile-landscape hide-mobile">
                  <a href="https://www.acheter-louer.fr/" target="_blank" rel="noopener noreferrer">
                    <img 
                      src="/logo-htl.png" 
                      loading="lazy" 
                      alt="Acheter-Louer" 
                      className="banner-image" 
                    />
                  </a>
                </div>
                <div className="nav_wrapper">
                  <Link to="/" className="nav_brand">
                    <div className="text-size-large" style={{fontSize: window.innerWidth <= 767 ? '0.81rem' : undefined}}>
                      <div className="text-weight-bold">
                        <div>SOL Treasury Corp</div>
                      </div>
                    </div>
                  </Link>

                  {/* Menu Burger pour Mobile */}
                  <div className="nav_button" style={{ 
                    display: window.innerWidth <= 767 ? 'block' : 'none',
                    position: 'absolute',
                    right: '1rem'
                  }}>
                    <button 
                      onClick={toggleMenu}
                      style={{
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        padding: '10px'
                      }}
                    >
                      <div style={{ 
                        width: '25px', 
                        height: '2px', 
                        background: '#FAFAFA', 
                        marginBottom: '6px',
                        transition: 'all 0.3s ease',
                        transform: menuOpen ? 'rotate(45deg) translate(5px, 5px)' : 'none'
                      }}></div>
                      <div style={{ 
                        width: '25px', 
                        height: '2px', 
                        background: '#FAFAFA',
                        opacity: menuOpen ? 0 : 1,
                        transition: 'all 0.3s ease'
                      }}></div>
                      <div style={{ 
                        width: '25px', 
                        height: '2px', 
                        background: '#FAFAFA', 
                        marginTop: '6px',
                        transition: 'all 0.3s ease',
                        transform: menuOpen ? 'rotate(-45deg) translate(5px, -5px)' : 'none'
                      }}></div>
                    </button>
                  </div>

                  {/* Menu Navigation */}
                  <div className="nav_menu" style={{
                    display: window.innerWidth <= 767 ? (menuOpen ? 'flex' : 'none') : 'flex',
                    flexDirection: window.innerWidth <= 767 ? 'column' : 'row',
                    position: window.innerWidth <= 767 ? 'absolute' : 'static',
                    top: window.innerWidth <= 767 ? '100%' : 'auto',
                    left: window.innerWidth <= 767 ? '0' : 'auto',
                    right: window.innerWidth <= 767 ? '0' : 'auto',
                    backgroundColor: window.innerWidth <= 767 ? '#222126' : 'transparent',
                    padding: window.innerWidth <= 767 ? '1rem' : '0',
                    width: window.innerWidth <= 767 ? '100%' : 'auto',
                    zIndex: 1000
                  }}>
                    <Link to="/press-release" className="nav-link_wrapper" onClick={() => setMenuOpen(false)}>
                      <div style={{fontSize: window.innerWidth <= 767 ? '0.81rem' : undefined}}>
                        Press Release
                      </div>
                    </Link>
                    <a href="#metrics-section" className="nav-link_wrapper" onClick={handleMetricsClick}>
                      <div style={{fontSize: window.innerWidth <= 767 ? '0.81rem' : undefined}}>
                        Metrics
                      </div>
                    </a>
                    <a href="#" className="nav-link_wrapper" onClick={(e) => {
                      openContactModal(e);
                      setMenuOpen(false);
                    }}>
                      <div style={{fontSize: window.innerWidth <= 767 ? '0.81rem' : undefined}}>
                        Contact Us
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <ContactForm 
        isOpen={contactModalOpen} 
        onClose={closeContactModal} 
      />
    </>
  );
};

export default Navigation;